<template>
  <div>
    <v-snackbar
      v-model="snackbar.snackbar"
      :bottom="true"
      :color="snackbar.color"
      :right="true"
      :multi-line="true"
      :timeout="timeout"
      :vertical="false"
    >
      {{ textFinal }}
    </v-snackbar>
  </div>
</template>

<script>
  export default {
    name: 'AlertSystem',
    props:{
      text: String,
      snackbar: {
        type: Object
      }
    },
    data: () => ({
      timeout: 5000,
      textFinal: ''
    }),
    watch:{
      textSnack () {
          this.textFinal = this.snackbar.text
      }
    },
    computed:{
      textSnack () {
        return this.snackbar.text
      }
    }
  }
</script>
